import { mapGetters } from "vuex";
import { getPermission } from "../services/permissions.js";

export const hasPermissionMixin = {
  computed: {
    ...mapGetters(["loggedUser"]),
  },

  methods: {
    async hasPermission(permission) {
      try {
        const res = await getPermission(permission, this.loggedUser.id);

        if (!res.data.has_permission) {
          console.error("Usuário sem permissão para realizar essa ação");
          return false;
        }

        return true;
      } catch (err) {
        console.error("Falha ao consultar permissão", err);
        return false;
      }
    },
  },
};
